import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3eec2f00")

_pushScopeId("data-v-3eec2f00")
const _hoisted_1 = { class: "flex-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("创建")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "创建项目",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogVisible = $event)),
    width: "40%"
  }, {
    default: _withId(() => [
      _createVNode(_component_el_form, {
        ref: "formDom",
        model: _ctx.formData,
        "label-width": "180px"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, { label: "关键字" }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.keyword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.keyword = $event)),
                placeholder: "请输入搜图关键字"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "" }, {
            default: _withId(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.formData.manualUpload,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.manualUpload = $event)),
                label: "是否手动上传图片"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              disabled: _ctx.formData.keyword.trim().length === 0,
              type: "success",
              onClick: _ctx.create
            }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})